(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider) {
        $stateProvider.state('contacto', {
            parent: 'public',
            url: '/contacto',
            data: {
                pageTitle: 'componentes.menu.contacto.titulo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/contacto/contacto.html'
                }
            },
            resolve: {
                /* @ngInject */
                translatePartialLoader: function ($translatePartialLoader) {
                    $translatePartialLoader.addPart('componentes/contacto');
                }
            }
        });
    }
})();
